import React, { useState } from 'react';
import { Grid, Typography, IconButton } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import api from '../../../services/api';
import ModalAddress from '../../ModalAddresses';
import { StyledDialogEdit } from '../styles';

const AddressBox = ({ label, address, isMobile, wid, onChange }) => (
  <Grid>
    <Typography style={{ margin: isMobile && '20px 0px' }}>{label}</Typography>
    <Grid
      style={{
        width: isMobile ? wid * 0.86 : 400,
        border: '1px solid #000000',
        padding: isMobile ? 12 : 25,
        margin: !isMobile && '30px 0px 40px',
      }}
    >
      <Typography
        style={{ fontWeight: 'bold', fontSize: 14, margin: '0px 0px 10px' }}
      >
        {address?.name}
      </Typography>
      <Typography style={{ fontSize: 14, margin: '10px 0px' }}>
        {address?.street} - {address?.building_unit_floor || ''}
      </Typography>
      <Typography style={{ fontSize: 14, margin: '10px 0px 0px' }}>
        {address?.city} - {address?.state_province}
      </Typography>
      <Typography style={{ fontSize: 14, margin: '10px 0px 0px' }}>
        {address?.zipcode} - {address?.country}
      </Typography>
    </Grid>
    <Grid
      container
      justifyContent="center"
      style={{ margin: isMobile && '20px 0px' }}
    >
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        onClick={onChange}
        style={{
          width: 220,
          height: 40,
          border: '1px solid #000000',
          cursor: 'pointer',
        }}
      >
        <Typography style={{ fontSize: 12 }}>Change address</Typography>
      </Grid>
    </Grid>
  </Grid>
);

export default function ShippingStep({
  isMobile,
  wid,
  profile,
  isShip,
  setIsShip,
  shipAdd,
  setShipAdd,
  billingAddresses,
  setBillingAddresses,
  selectedShipAddress,
  setSelectedShipAddress,
  selectedBillingAddress,
}) {
  const [openShip, setOpenShip] = useState(false);
  const [openAddress, setOpenAddress] = useState(false);
  const [editId, setEditId] = useState(-1);
  const [editValues, setEditValues] = useState({});

  const addresses = isShip ? shipAdd : billingAddresses;

  const persistAddresses = allAddresses =>
    api.put('/account', {
      id: profile.account,
      addresses: allAddresses,
    });

  const handleCloseModalAddress = () => {
    setOpenAddress(false);
    setEditId(-1);
  };

  const handleCloseChooser = () => {
    setOpenShip(false);
    setOpenAddress(false);
  };

  const handleDeleteAddress = index => {
    const newArr = shipAdd.filter((item, i) => index !== i);
    setShipAdd(newArr);
    persistAddresses([...newArr, ...billingAddresses]);
  };

  const handleOpenEdit = (address, index) => {
    setOpenAddress(true);
    setEditValues({
      modalAddress: address.name,
      modalCity: address.city,
      modalStoreProv: address.state_province,
      modalZipcode: address.zipcode,
      modalStreet: address.street,
      modalUnit: address.building_unit_floor,
      modalCountry: address.country,
    });
    setEditId(index);
  };

  const translateModalAddress = address => ({
    name: address.modalAddress,
    street: address.modalStreet,
    building_unit_floor: address.modalUnit,
    city: address.modalCity,
    state_province: address.modalStoreProv,
    country: address.modalCountry,
    zipcode: address.modalZipcode,
    isBillingAddress: !isShip,
    isShippingAddress: isShip,
  });

  const handleSaveAddress = address => {
    const translated = translateModalAddress(address);
    let allAddresses = [];
    if (editId === -1) {
      if (isShip) {
        setShipAdd([...shipAdd, translated]);
      } else {
        setBillingAddresses([...billingAddresses, translated]);
      }
      allAddresses = [...shipAdd, ...billingAddresses, translated];
    } else if (isShip) {
      const newArr = shipAdd.map((item, i) =>
        i !== editId ? item : translated
      );
      setShipAdd(newArr);
      allAddresses = [...newArr, ...billingAddresses];
    } else {
      const newArr = billingAddresses.map((item, i) =>
        i !== editId ? item : translated
      );
      setBillingAddresses(newArr);
      allAddresses = [...shipAdd, ...newArr];
    }
    persistAddresses(allAddresses);
    handleCloseModalAddress();
  };

  return (
    <Grid container justify="center" alignItems={isMobile && 'center'}>
      <ModalAddress
        open={openAddress}
        handleClose={handleCloseModalAddress}
        handleSaveAddress={handleSaveAddress}
        editValues={editValues}
      />
      <StyledDialogEdit
        open={openShip}
        BackdropProps={{ style: { borderRadius: 5 } }}
        onClose={handleCloseChooser}
        style={{
          minHeight: 715,
          width: 350,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 2000,
        }}
      >
        <Grid style={{ height: 715, padding: '5%', overflowX: 'hidden' }}>
          <Grid container justify="space-between" alignItems="center">
            <Typography>
              {isShip ? 'Shipping Address' : 'Billing Address'}
            </Typography>
            <IconButton onClick={handleCloseChooser}>
              <ClearIcon />
            </IconButton>
          </Grid>
          <Grid style={{ width: 350 }}>
            {addresses.map((address, index) => {
              const selected = index === selectedShipAddress;
              const mutedColor = !selected ? '#d3d3d3' : undefined;
              return (
                <Grid
                  key={`${address?.name}-${address?.street}-${address?.zipcode}`}
                  onClick={() => !selected && setSelectedShipAddress(index)}
                  style={{
                    cursor: 'pointer',
                    padding: '11px 15px 4px',
                    width: 320,
                    height: 102,
                    border: selected
                      ? '1px solid #000000'
                      : '1px solid #d3d3d3',
                    marginTop: 10,
                  }}
                >
                  <Typography
                    style={{
                      fontSize: 12,
                      fontWeight: 'bold',
                      marginBottom: 12,
                      color: mutedColor,
                    }}
                  >
                    {address?.name}
                  </Typography>
                  <Grid container justifyContent="space-between">
                    <Grid style={{ width: 200 }}>
                      <Typography
                        style={{
                          fontSize: 12,
                          lineHeight: '10px',
                          color: mutedColor,
                        }}
                      >{`${address?.street} - ${address?.building_unit_floor}`}</Typography>
                      <Typography
                        style={{
                          fontSize: 12,
                          lineHeight: '10px',
                          color: mutedColor,
                        }}
                      >{`${address?.city} - ${address?.state_province}`}</Typography>
                      <Typography
                        style={{
                          fontSize: 12,
                          lineHeight: '10px',
                          color: mutedColor,
                        }}
                      >{`${address?.zipcode} - ${address?.country}`}</Typography>
                    </Grid>
                    <Grid style={{ width: 46 }}>
                      <Typography
                        onClick={event => {
                          event.stopPropagation();
                          handleOpenEdit(address, index);
                        }}
                        align="right"
                        style={{
                          fontSize: 12,
                          color: mutedColor,
                          cursor: 'pointer',
                          zIndex: 5000,
                        }}
                      >
                        Edit
                      </Typography>
                      {shipAdd.length > 1 && (
                        <Typography
                          align="right"
                          style={{
                            fontSize: 12,
                            cursor: 'pointer',
                            color: mutedColor,
                          }}
                          onClick={event => {
                            event.stopPropagation();
                            handleDeleteAddress(index);
                          }}
                        >
                          Remove
                        </Typography>
                      )}
                    </Grid>
                    <Grid />
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
          <Grid container justifyContent="center" style={{ marginTop: 20 }}>
            <Grid
              container
              style={{
                width: 216,
                height: 36,
                alignItems: 'center',
                border: '1px solid #000000',
                cursor: 'pointer',
              }}
              justifyContent="center"
              onClick={() => {
                setOpenShip(false);
                setOpenAddress(true);
              }}
            >
              <Typography style={{ fontSize: 12 }}>Add address +</Typography>
            </Grid>
          </Grid>
        </Grid>
      </StyledDialogEdit>
      <Grid
        style={{
          width: isMobile ? '86%' : '60%',
          borderBottom: !isMobile && '1px solid #000000',
          padding: !isMobile && '36px 0px',
        }}
      >
        {!isMobile && (
          <Typography align="center">
            Please review your billing and shipping information for your order
          </Typography>
        )}
      </Grid>
      <Grid
        container
        justifyContent={isMobile ? 'center' : 'space-between'}
        style={{ width: isMobile ? '86%' : 1000, marginTop: 60 }}
      >
        <AddressBox
          label="Billing address"
          address={billingAddresses[selectedBillingAddress]}
          isMobile={isMobile}
          wid={wid}
          onChange={() => {
            setOpenShip(true);
            setIsShip(false);
          }}
        />
        <AddressBox
          label="Shipping address"
          address={shipAdd[selectedShipAddress]}
          isMobile={isMobile}
          wid={wid}
          onChange={() => {
            setOpenShip(true);
            setIsShip(true);
          }}
        />
      </Grid>
    </Grid>
  );
}
